<div class="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-[9999]">
  <div class="relative
           bg-gradient-to-br from-gray-800 to-gray-900
           text-white p-7 rounded-2xl shadow-2xl
           w-[340px] text-center
           border border-gray-700">

    <!-- Close Icon (Top Right) -->
    <span role="button" tabindex="0" (click)="onClose()" class="
        absolute top-3 right-3
        w-8 h-8
        flex items-center justify-center
        rounded-full
        text-gray-400 hover:text-white
        hover:bg-white/10
        cursor-pointer
        transition
      ">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </span>

    <!-- Icon -->
    <div class="flex justify-center mb-4">
      <div class="w-12 h-12 flex items-center justify-center rounded-full bg-yellow-500/20">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-yellow-400" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01M12 3a9 9 0 110 18 9 9 0 010-18z" />
        </svg>
      </div>
    </div>

    <!-- Title -->
    <h2 class="text-xl font-semibold mb-2">
      {{ title }}
    </h2>

    <!-- Message -->
    <p class="text-gray-300 text-sm leading-relaxed mb-6">
      {{ message }}
    </p>

    <!-- Action -->
    <button type="button" (click)="onAction()" class="w-full py-2.5 rounded-lg
             bg-cyan-500 hover:bg-cyan-600
             font-medium
             transition-all duration-200">
      {{ buttonText }}
    </button>
  </div>
</div>
